// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"837":"3b4ddcf8","965":"cf6d48a7"}[chunkId] + ".chunk.js");